var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Doughnut',{ref:"pieChart",class:_vm.classes,attrs:{"chart-options":_vm.finalChartOptions,"chart-data":_vm.finalChartData,"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey,"plugins":_vm.plugins,"css-classes":_vm.cssClasses,"styles":_vm.styles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }